var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineRightDeco = function SvgLineRightDeco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m44.5 27.205-30.5 31",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34 3.205-32 51",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
export { SvgLineRightDeco as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDcgNjEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00NC41IDI3LjIwNTFMMTQgNTguMjA1MSIgc3Ryb2tlPSIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWRhc2hhcnJheT0iNCA0Ii8+CjxwYXRoIGQ9Ik0zNCAzLjIwNTA4TDIgNTQuMjA1MSIgc3Ryb2tlPSIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L3N2Zz4K";